import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { IInputProps } from 'types/components/inputs/input.interface';

const TextInputForm = ({ name, isError = true, ...props }: IInputProps) => {
  const [field, { error, value, status }] = useFormikField<string>(name);

  return (
    <Input.Text
      displayMode={status?.displayMode}
      isLoading={status?.isLoading}
      {...props}
      {...field}
      value={value}
      onChange={e => {
        props.onChange && props.onChange(e);
        field.onChange(e);
      }}
      error={error}
    />
  );
};

export default TextInputForm;
